module.exports = __webpack_public_path__ + "img/cover8.4033645f.png";